// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__51TPe","title":"ClientCherryInfo_title__3B4Oy","itemText":"ClientCherryInfo_itemText__2ZPy3"};